import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomizedHttpService } from '../base/customized-http.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProcessCounterService {
  constructor(private httpService: CustomizedHttpService, @Inject('BASE_URL') private originUrl: string) { }

  processCounter(counter: string): Observable<any> {
    return this.httpService.getByQuery<any>(`${this.originUrl}Counter/ProcessCounter`, new HttpParams().set("counterName", counter));
  }
  processSessionExpiryCounter(sessionTrackingId: string): Observable<boolean> {
    return this.httpService.post<any, boolean>(`${this.originUrl}counter/sessionExpiryCounter`, { sessionTrackingId: sessionTrackingId });
  }
}
